"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documents = void 0;
exports.documents = {
    headings: {
        documents: "Documents",
    },
    labels: {
        invoice: "Invoice",
        wasteTransferNote: "Waste Transfer Note",
        consignmentNote: "Consignment Note",
    },
    status: {
        none: "None",
        download: "Download",
        pending: "Pending",
        comingSoon: "Coming soon",
        notAvailable: "Not available",
    },
    tooltips: {
        wtnPending: "The waste transfer note will be available once collection information has been filled out (waste types, cubic yards collected, and estimated weight).",
        consignmentComingSoon: "Consignment note worksheets have been completed. The download will be available soon.",
    },
    errors: {
        downloadInvoice: "Failed to download the invoice. Please try again.",
        downloadWTN: "Failed to download the waste transfer note. Please try again.",
    },
};
